import React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import type { AppStore } from '@stores/app/store';
import H5 from './layout/h5';
import type { AddressFormRouteState } from './layout/common/AddressFormContent';
import styles from './index.module.scss';

interface AddressFormProps extends RouteComponentProps<{}, {}, AddressFormRouteState> {
    app?: AppStore;
}

// 地址页面根入口：PC 保留站点外壳，表单正文统一使用 H5 页面。
class AddressForm extends React.Component<AddressFormProps> {
    private restoreRootFontSize?: () => void;

    private syncDesktopBodyClass = () => {
        if (typeof document === 'undefined') return;
        document.body.classList.toggle('address-form-desktop', this.props.app?.platform === 'pc');
    };

    private syncH5RemOnDesktop = () => {
        if (typeof window === 'undefined' || this.props.app?.platform !== 'pc') return;

        const root = document.documentElement;
        if (root.style.fontSize === '100px') return;
        const previousFontSize = root.style.fontSize;
        root.style.fontSize = '100px';
        this.restoreRootFontSize = () => {
            if (root.style.fontSize === '100px') {
                root.style.fontSize = previousFontSize;
            }
        };
    };

    componentDidMount() {
        this.syncH5RemOnDesktop();
        this.syncDesktopBodyClass();
    }

    componentDidUpdate() {
        this.syncH5RemOnDesktop();
        this.syncDesktopBodyClass();
    }

    componentWillUnmount() {
        this.restoreRootFontSize?.();
        document.body.classList.remove('address-form-desktop');
    }

    render() {
        const { app } = this.props;
        if (!app?.platform) {
            return <div className={styles.loading}>加载中...</div>;
        }

        return <div className={styles.h5Wrap}>
            <H5 {...this.props} desktopMode={app.platform === 'pc'} />
        </div>;
    }
}

export default withRouter(inject('app')(observer(AddressForm)));
